<div id="viewer-container" class="viewer-container">
  <!-- Fullscreen Exit Button -->
  @if (isFullscreen) {
    <button
      type="button"
      class="btn btn-outline-dark btn-fullscreen"
      (click)="exitFullscreen()">
      <fa-icon [icon]="icons.exitFullscreen"></fa-icon>
    </button>
  }
  <!-- End Fullscreen Exit Button -->
  <!-- Alert Container -->
  <div
    class="d-flex position-absolute justify-content-center flex-row alert-container">
    <!-- Error Alert -->
    @if (appService.selectedCamera?.HasError && !appService.isImageLoading) {
      <div class="position-absolute align-self-center">
        <ngb-alert
          type="danger"
          [dismissible]="false"
          class="viewer-alert shadow-lg">
          <div style="display: grid; grid-template-rows: 1fr 2.5em 1fr">
            <h4>{{ appService.selectedCamera.Name }}</h4>
            <p class="h5 text-center">
              <fa-icon [icon]="icons.exclamation"></fa-icon>
              {{
                appService.selectedCamera.ErrorMessage ||
                  'An error occurred while loading the camera image.'
              }}
            </p>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-outline-dark"
                (click)="appService.refreshCamera(true)">
                Retry
              </button>
            </div>
          </div>
        </ngb-alert>
      </div>
    }
    <!-- End Error Alert -->

    <!-- Loading Alert -->
    @if (appService.isImageLoading) {
      <div class="position-absolute align-self-center">
        <ngb-alert
          type="warning"
          [dismissible]="false"
          class="viewer-alert shadow-lg">
          <h3 class="text-nowrap text-truncate">
            {{ appService.selectedSite?.Name }}
          </h3>
          <h5>
            <div class="text-nowrap text-truncate">
              <fa-icon [icon]="icons.spinner" animation="spin-pulse"></fa-icon>
              <span class="">{{ loadingMsg || 'Loading Image...' }}</span>
            </div>
          </h5>
        </ngb-alert>
      </div>
    }
    <!-- End Loading Alert -->
  </div>
  <!-- End Alert Container -->

  <!-- Image Container -->
  <div class="img-container" id="image-container">
    <!-- Mobile Nav Buttons -->
    @if (appService.selectedSite && !appService.isImageLoading) {
      <button
        class="btn btn-sm btn-outline-light btn-img-left btn-nav d-xl-none"
        (click)="appService.previousCamera()"
        [disabled]="appService.isImageLoading">
        <fa-icon [icon]="icons.previous"></fa-icon>
      </button>
    }

    @if (appService.selectedSite && !appService.isImageLoading) {
      <button
        class="btn btn-sm btn-outline-light btn-img-right btn-nav d-xl-none"
        (click)="appService.nextCamera()"
        [disabled]="appService.isImageLoading">
        <fa-icon [icon]="icons.next"></fa-icon>
      </button>
    }
    <!-- End Mobile Nav Buttons -->
    <!-- The Actual Image -->
    @if (!appService.selectedCamera?.HasError) {
      <div class="">
        <img [src]="imageSrc" class="img-pos shadow-lg" />
      </div>
    }
  </div>
  <!-- End Image Container -->
</div>
